import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import formaturaImg from "@/assets/formatura.png"
import pesFirmesImg from "@/assets/pes-caminhando-novo.png"
import logo from "@/assets/logo-25segundos-horizontal.png"
import { PageLayout } from "./PageLayout"

interface AboutTestProps {
  onContinue: () => void
}

export function AboutTest({ onContinue }: AboutTestProps) {
  return (
    <PageLayout>
      <Card className="max-w-4xl w-full p-6 md:p-8 shadow-elegant">
        <div className="text-center space-y-4">
          <div className="flex justify-center">
            <img src={logo} alt="25 Segundos" className="h-20 w-auto" />
          </div>

          <div className="flex justify-center">
            <img
              src={formaturaImg}
              alt="Formatura"
              className="w-32 h-32 object-contain"
            />
          </div>

          <div className="space-y-3">
            <h2 className="text-xl md:text-2xl font-bold text-title-blue">
              Para quem é este teste?
            </h2>

            <p className="text-sm md:text-base text-foreground leading-relaxed">
              A Orientação Profissional 25Método S.E.M.E.A.R. foi desenvolvida especialmente para jovens a partir do Ensino Médio,
              que estão em fase de descoberta, escolha e definição de caminhos profissionais.
            </p>

            <p className="text-sm md:text-base text-foreground leading-relaxed">
              Mais do que indicar uma profissão, ele ajuda você a entender suas preferências, talentos e motivações,
              conectando suas escolhas ao seu propósito de vida.
            </p>
          </div>

          <div className="flex justify-center">
            <img
              src={pesFirmesImg}
              alt="Pés firmes"
              className="w-40 h-40 object-contain"
            />
          </div>

          <p className="text-base md:text-lg text-accent font-medium italic">
            Um passo consciente para escolher com o coração e agir com clareza.
          </p>

          <Button
            onClick={onContinue}
            size="lg"
            className="bg-gradient-primary hover:opacity-90 transition-opacity text-lg px-12 py-6 h-auto shadow-elegant hover-scale mt-8"
          >
            ⮕ Continuar
          </Button>
        </div>
      </Card>
    </PageLayout>
  )
}
